
export default function FormatNumber(number) {
	//console.log('||=>', number)
	if(number==="") return 0
	let numero = new Intl.NumberFormat('es-CL').format(number);
	//return numero.replace(/,/g,'.')
	return numero
}
